import { render, staticRenderFns } from "./UserPropertiesBox.vue?vue&type=template&id=1e1da33d"
import script from "./ts/UserPropertiesBox.ts?vue&type=script&lang=ts&external"
export * from "./ts/UserPropertiesBox.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports